/* eslint-disable no-console */
import { datadogRum } from '@datadog/browser-rum';

const debugEnv = import.meta.env.DEV;
const DEBUG_ENABLED = false;
export const debug = (...data) => {
  if (DEBUG_ENABLED) console.debug(...data);
};

const logError = (err, ctx = undefined) => {
  if (debugEnv) {
    console.error(err, ctx);
    return;
  }
  datadogRum.addError(err, ctx);
};

export const logCatch = (fn = () => {}, expected = []) => (err) => {
  if (!expected.includes(err.data?.code)) {
    logError(err);
  }
  return fn(err);
};
